// removed by extract-text-webpack-plugin
module.exports = {"default":"_1k-7U","red":"_3HY1A","black":"o8Uro","white":"_28al3","button":"_3AmDY","button_black":"_2E3Uc","button_grey":"_2CAci"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/StyledText/StyledTextComponents/Link.scss
 ** module id = 447
 ** module chunks = 0
 **/